import React from 'react';
import useAppSelector from '../app/redux/useAppSelector';
import Avatar from '../components/Avatar';
import Button from '../components/Button';
import apiIcon from '../icons/api.svg';
import arrowLeft from '../icons/arrowLeft.svg';
import auditIcon from '../icons/audit.svg';
import authenticationIcon from '../icons/authentication.svg';
import billingIcon from '../icons/billing.svg';
import importExportIcon from '../icons/importExport.svg';
import integrationIcon from '../icons/integration.svg';
import profileIcon from '../icons/member.svg';
import notificationIcon from '../icons/notifications.svg';
import provisionsIcon from '../icons/provisions.svg';
import teamIcon from '../icons/team.svg';
import TeamIcon from '../organization/TeamIcon';
import SettingsNavItem from './SettingsNavItem';
import styles from './SettingsSidebar.module.scss';

const SettingsSidebar = () => {
  const user = useAppSelector((state) => state.session.user);

  return (
    <>
      <div className={styles.section}>
        <Button className={styles.homeButton} to="/" icon={arrowLeft}>
          Back Home
        </Button>
        <h5>Me</h5>
        <SettingsNavItem
          icon={<Avatar user={user} size="small" />}
          to="/settings/profile"
        >
          Profile
        </SettingsNavItem>
        <SettingsNavItem icon={profileIcon} to="/settings" onlyActiveOnIndex>
          Account
        </SettingsNavItem>
        <SettingsNavItem icon={notificationIcon} to="/settings/notifications">
          Notifications
        </SettingsNavItem>
      </div>
      {user.type === 'ADMIN' && (
        <div className={styles.section}>
          <h5>My Team</h5>
          <SettingsNavItem icon={<TeamIcon size="small" />} to="/admin/team">
            Team
          </SettingsNavItem>
          <SettingsNavItem icon={teamIcon} to="/admin/teammates">
            Teammates
          </SettingsNavItem>
          <SettingsNavItem icon={authenticationIcon} to="/admin/authentication">
            Authentication
          </SettingsNavItem>
          <SettingsNavItem icon={provisionsIcon} to="/admin/provisions">
            Provisions
          </SettingsNavItem>
          <SettingsNavItem icon={integrationIcon} to="/admin/integrations">
            Integrations
          </SettingsNavItem>
          <SettingsNavItem icon={billingIcon} to="/admin/billing">
            Billing
          </SettingsNavItem>
          <SettingsNavItem icon={auditIcon} to="/admin/audit">
            Audit Logs
          </SettingsNavItem>
          <SettingsNavItem icon={apiIcon} to="/admin/developer">
            Developer
          </SettingsNavItem>
          <SettingsNavItem icon={importExportIcon} to="/admin/import">
            Import &amp; Export
          </SettingsNavItem>
        </div>
      )}
    </>
  );
};

export default SettingsSidebar;
